// extracted by mini-css-extract-plugin
module.exports = {"link":"styles_link__24-Pn","title":"styles_title__2XjVJ","divider":"styles_divider__2ITNg"};